import { FC } from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';

type PageTitleProps = {
	children?: string;
};

export const PageTitle: FC<PageTitleProps> = ({ children }) => {
	const text = ['Bonusly', children].filter(Boolean).join(' • ');

	return (
		<HelmetProvider>
			<Helmet>
				<title>{text}</title>
			</Helmet>
		</HelmetProvider>
	);
};
